omadapp.controllers.quizController = function ($page) {
	var t = this
	var $ = jQuery
	var App = omadapp.App
	t.preparePage = preparePage

	t.onPreCurrent = onPreCurrent
	t.onExit = onExit
	t.setScore = setScore
	t.navigate = navigate
	t.getJSON = getJSON
	var controllersMap = omadappData.sceneControllerMap
	var $js_content = $page.find(".js_content")
	var $js_progress_bar = $page.find(".js_progress_bar")
	var $js_question_number = $page.find(".js_question_number")
	var $js_current_question = $js_question_number.find(".js_current_question")
	var $js_total_questions = $js_question_number.find(".js_total_questions")
	var $js_score_counter = $page.find(".js_score .js_counter")
	var sControllers = omadapp.controllers.scenes
	var genTrans = omadapp.singletons.gestorTransiciones
	var progressBar = new omadapp.components.ProgressBar($js_progress_bar)
	var controllers = [];
	var scores = {}
	var json
	$page.on("linearNav.prev",prevScene)
	$page.on("linearNav.next",nextScene)

	var $js_next_button = $page.find(".js_continue")

	$js_next_button.click(function(e) {
		e.preventDefault()
		nextScene(e,$page.find(".scene.current").prop("controller"))
	})


	function prevScene(e,scene) {
		if (scene.prevScene) {
			navigate(scene.prevScene.nid,"slideRight")
		}

		e.preventDefault()
	}

	function nextScene(e,scene) {
		trace ("multipage::nextScene")
		//trace (scene.nextScene)
		if (scene.nextScene) {
			navigate(scene.nextScene.nid,"slideLeft")
		} else {
			$page.trigger("quizz-ended",scores)
		}
		e.preventDefault()
	}

	function clear () {
		//trace (controllers)
		while (controllers.length>0) {
			var xx = controllers.pop()
			//trace (xx)
			xx.kill()
		}
		json = null
	}

	function prepareIndex (data) {
		var itm = data[0]
		if (itm.type!="index_page") {
			var indx = {
				type: "index_page",
				title: itm.title,
				body: "",
				image: itm.image,
				nid:"index"
			}
			data.unshift(indx)
		}
	}

	function onPreCurrent() {
		preparePage(App.config.quizz)
		trace ("quizController::onPreCurrent")
		$js_score_counter.text(0)
		trace ($js_score_counter)
		scores = {}
		waitForNavigate($page.find(".scene:eq(0)").attr("data-nid"))
		
	}

	function waitForNavigate(id) {
		trace ("waitForNavigate "+id)
		if (!genTrans.transicionando) {
			navigate(id)
		} else {
			setTimeout(function() {
 				waitForNavigate(id) 
			},10)
		}
	}

	function preparePage (data) {
		clear();
		trace ("multipage::preparePage")
		//trace (data)
		json = data;
		if (data.track_score!="0") {
			$page.addClass("track-score")
		} else {
			$page.removeClass("track-score")
		}

		for (var n in json.questions) {
			var itm = json.questions[n]
			itm.nid = n
			createPage (itm)
		}

		for (var i = 1; i < controllers.length; i++) {
			var scn = controllers[i]
			scn.setPrev(controllers[i-1])
			controllers[i-1].setNext(scn)
		}
	
		if (controllers.length==0) {
			console.warn("no hay páginas")
			return
		} 

		$js_progress_bar.addClass("hidden")
		//controllers[0].$page.addClass("current")
	}

	function getSceneController(nid) {
		return  controllers.find(element => element.nid == nid);
	}

	function getPageIndex (nid) {
		return  controllers.findIndex(element => element.nid == nid);
	}

	function navigate (nid,transition,callback,forze) {
		trace("multipage::navigate "+nid)
		if (genTrans.transicionando) {
			trace ("genTrans.transicionando")
			return
		}
		transition = transition||"corte";

		var incoming = getSceneController(nid)
		var outgoing_nid =$page.find(".scene.current").attr("data-nid")
		var outgoing = getSceneController(outgoing_nid)
		trace (incoming)
		trace (outgoing)
		if (outgoing) {
			var tam = outgoing.$page.height()
			$js_content.css({
				"min-height": tam+"px"
			})
		}
		$page.trigger("omadapp.scene.prenavigation",[incoming,outgoing])
		genTrans.generarTransicion (incoming,outgoing,transition,null,function(a,b) {
			$page.attr("data-page-type",incoming.$page.attr("data-type"))
			$js_progress_bar.attr("data-page-type",incoming.$page.attr("data-type"))
			$js_progress_bar.removeClass("hidden")
			var pageNumber = (getPageIndex(incoming.nid)+1)
			var percent = (pageNumber/(controllers.length))*100
			$js_current_question.text (pageNumber)
			$js_total_questions.text(controllers.length)
			progressBar.setPercentage(percent)
			trace ("navegación completada")
			if(callback) {
				callback(a,b)
			}
			$js_content.attr("style","")
		})
	}

	function createPage(data) {
		var type = data.type

		var x,tmpName
		var tmpName = type
		x = sControllers.quizz_question

		data.tmp_id = tmpName
		trace ($(".tmps .js_scenes_tmps ")[0])
		var $p = $(".tmps .js_scenes_tmps [data-type=quizz_question]").clone()
		$js_content.append($p)
		trace ($p)


		$p.attr("data-nid",data.nid)
		var controller = new x($p,data)
		controller.inherit = controller.inherit || omadapp.controllers.scenes.common_methods.heredar
		controller.inherit(sControllers.common_question_methods)
		controller.mainPage = t
		controller.$page = $p
		controller.nid = data.nid
		controller.initialize()
		controllers.push(controller)
		$p.prop("controller",controller)
		return controller
		
	}

	function calculateScore() {
		var res = 0
		for (var n in scores) {
			res+=scores[n]
		}
		return res;
	}

	function setScore (idQuestion,score) {
		trace ("quizController::setScore "+idQuestion)
		trace (score)
		scores[idQuestion] = score
		$js_score_counter.text(calculateScore())
	}

	function getJSON () {
		return json
	}
	
	function onExit() {
	}

}